import { db } from "../../firebase";
import { USERS, TRANSACTIONS } from "../Collections";

const transactionsRef = uid => db.collection(`${USERS}/${uid}/${TRANSACTIONS}`)

export const getAll = uid => transactionsRef(uid)
export const getAllByStrategy = (uid, strategyId) => getAll(uid).where('strategy.id', '==', strategyId)
